<div
  class="relative"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <!-- Popover icon -->
  <div class="relative flex flex-col justify-center items-center">
    <button type="button">
      <svg
        class="w-3.5 h-3.5 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white cursor-pointer"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"
        />
      </svg>
    </button>
    <!-- Arrow -->
    <div
      class="absolute z-20 top-5 rotate-45 w-2 h-2 border-b-0 border-r-0 text-gray-500 bg-white border border-gray-200 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400 transition-opacity duration-300 ease-in-out"
      [ngClass]="isHovered ? 'opacity-100 visible' : 'opacity-0 invisible'"
    ></div>
  </div>
  <div
    id="popover-description"
    role="tooltip"
    class="absolute top-6 z-10 -left-56 text-sm text-gray-500 bg-white border border-gray-200 rounded-lg shadow-xs w-72 dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400 transition-opacity duration-300 ease-in-out"
    [ngClass]="isHovered ? 'opacity-100 visible' : 'opacity-0 invisible'"
  >
    <div class="p-3 space-y-2">
      <h3 class="font-semibold text-gray-900 dark:text-white">Note:</h3>
      <ul class="space-y-2">
        <li>
          @if (infoType === "infoPerennialTreeForecasting") {
            <p>
              ET forecasting is only representative of mature trees & vines and
              therefore should not be used on young perennial crops. Historical
              ranges represent ET values from throughout the San Joaquin Valley
              and are not specific to this district/GSA.
            </p>
          } @else if (infoType === "estimatedCTC") {
            <p>
              This values represents an estimate of the district/GSA-wide
              year-to-date cumulative total consumption of water. Cumulative avg
              ET provided above for claimed fields only is extrapolated out to
              all fields, regardless of claimed status. Depending on crop mix
              and grower participation, this extrapolation may not be
              representative of the district/GSA.
            </p>
          } @else if (infoType === "totalTargetWater") {
            <p class="font-normal text-sm text-gray-500 dark:text-gray-300">
              Total Target Water is compared against field ET. Therefore, this
              input should be representative of ET contributions from both
              precipitation and irrigation.
            </p>
          } @else if (infoType === "preclaimedAcknowledgement") {
            <p class="font-normal text-sm text-gray-500 dark:text-gray-300">
              Field information has been pre-populated based on historical data
              and crop type averages.
            </p>
          }
        </li>
      </ul>
    </div>
  </div>
</div>
